import { Box } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import React from "react";
import "react-toastify/dist/ReactToastify.css";
import ReactTooltip from "react-tooltip";
import { DOWNLOAD } from "../../constants/index";
import { useStyles } from "./styles";
function MultipleImageDownloadIcon({ item }) {
  const openImageInNewTab = (url, index) => {
    setTimeout(() => {
      window.open(url, "_blank");
    }, index * 100);
  };
  const handleOpenAllImages = () => {
    item?.mobile_damage_photos?.forEach((url, index) => {
      openImageInNewTab(url, index);
    });
  };
  return item &&
    item.mobile_damage_photos &&
    item.mobile_damage_photos.length > 0 ? (
    <Box
      data-tip={`${DOWNLOAD} all images`}
      m={2}
      onClick={handleOpenAllImages}
      style={{ cursor: "pointer" }}
    >
      <CloudDownloadIcon fontSize="large" />
      <ReactTooltip html={true} />
    </Box>
  ) : null;
}
export default withStyles(useStyles, { withTheme: true })(
  MultipleImageDownloadIcon
);
